// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sz28","left":"styles_left__2JnYq"};